function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import allowPersonalisedAds from '../allowPersonalisedAds';
import providerUtil from './providerUtil';
import { getFeatureToggle } from '../utils/featureTogglesUtils';
import { getKruxSegments, getKruxUID } from '../krux';
var getClient = providerUtil.getClient,
    getServerUrlPart = providerUtil.getServerUrlPart,
    getViewIdUrlPart = providerUtil.getViewIdUrlPart,
    getPageParamUrlPart = providerUtil.getPageParamUrlPart,
    getUniqueParamUrlPart = providerUtil.getUniqueParamUrlPart,
    getAdType = providerUtil.getAdType;
var AdvertorialSas = {};

var getBaseSasURL = function getBaseSasURL() {
  return getFeatureToggle('sasStaging') ? 'https://reasfdc-ads.aimatch.com/' : 'https://sasinator.realestate.com.au/';
};

var PARAMS_BLACKLIST = ['sect', 'tile', 'type', 'dcopt', 'areaprefix', 'channel'];

var getKruxParamsUrlPart = function getKruxParamsUrlPart() {
  if (!allowPersonalisedAds()) {
    return '/dnt=1';
  }

  var params = '';
  var kruxUID = getKruxUID();
  var kruxSegments = getKruxSegments();

  if (kruxSegments.length > 0) {
    params += "/segment=".concat(kruxSegments.join(','));
  }

  if (kruxUID.length > 0) {
    params += "/kxkuid=".concat(kruxUID);
  }

  return params;
};

var getPrebidParamUrlPart = function getPrebidParamUrlPart(bidResult) {
  if (!bidResult) {
    return '';
  }

  return Object.entries(bidResult).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(acc, "/").concat(key, "=").concat(value);
  }, '/hb=1');
};

var getSasStagingPart = function getSasStagingPart() {
  if (!getFeatureToggle('sasStaging')) {
    return '';
  }

  return '/test=1';
};

AdvertorialSas.generateAdLink = function (adSpot, bidResult) {
  var url = "".concat(getBaseSasURL()) + "".concat(getClient()) + "".concat(getServerUrlPart(adSpot.config.type)) + "".concat(getViewIdUrlPart(adSpot.viewId)) + "".concat(getPageParamUrlPart(adSpot, PARAMS_BLACKLIST)) + "".concat(getKruxParamsUrlPart()) + "".concat(getAdType(adSpot.config.type)) + "".concat(getUniqueParamUrlPart(adSpot, PARAMS_BLACKLIST)) + "".concat(getPrebidParamUrlPart(bidResult)) + "".concat(getSasStagingPart());
  return url;
};

export default AdvertorialSas;
//# sourceMappingURL=sasProvider.js.map